import { useEffect, useRef, useState } from "react";

// Keeps the "generating" state on until the refetch that a finished job triggers has landed.
// The job leaves the running list before its result is refetched, so reading the job alone
// drops the loader onto stale (or empty) data for the length of that refetch.
export function useGeneratingUntilFetched(isGenerating: boolean, isFetching: boolean): boolean {
  const [settling, setSettling] = useState(false);
  const wasGenerating = useRef(isGenerating);
  const sawFetch = useRef(false);

  useEffect(() => {
    if (wasGenerating.current && !isGenerating) {
      setSettling(true);
      sawFetch.current = false;
    }
    wasGenerating.current = isGenerating;
  }, [isGenerating]);

  useEffect(() => {
    if (!settling) {
      return;
    }
    if (isFetching) {
      sawFetch.current = true;
    } else if (sawFetch.current) {
      setSettling(false);
    }
  }, [settling, isFetching]);

  return isGenerating || settling;
}
